var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.customFieldGroup && _vm.groupCustomFields.length > 0
      ? _c("fieldset", [
          _c("legend", [
            _vm._v(
              _vm._s(
                _vm.customFieldGroup.group === _vm.standaloneFieldsGroupName
                  ? ""
                  : _vm.customFieldGroup.label
              )
            ),
          ]),
          _c(
            "div",
            { staticClass: "md-layout" },
            _vm._l(_vm.groupCustomFields, function (customField, index) {
              return _c("CustomFieldInputs", {
                key: index,
                staticClass: "md-layout-item",
                attrs: {
                  "custom-field-definition": customField,
                  "initial-value": _vm.localGroupValues[customField.name],
                },
                on: { changed: _vm.handleCustomFieldChanged },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }